import { styled } from 'styled-components';
import { applyFeatureButtonStyle } from '../../app-kit/helpers/featureButtonStyle';
import {
  spacingHelper,
  typographyHelper,
  paletteHelper,
  mediaHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';

import { WebLink, WebLinkProps } from '../../app-kit/components/WebLink/WebLink';

export const SearchByImageFeatureButtonWrapper = styled.div`
  ${applyFeatureButtonStyle('searchByImage')};
`;

const FeatureButton = styled(WebLink)`
  ${typographyHelper('subtitle03')};
  color: ${paletteHelper('textInvertedStatic')};

  ${mediaHelper('tabletMax')} {
    padding: 0;
  }

  .label {
    ${mediaHelper('tabletMax')} {
      display: none;
      margin-left: ${spacingHelper('extraSmall')};
    }
  }
`;

export const SearchByImageFeatureButton: FunctionComponent<{
  searchByImageButton: WebLinkProps | null;
}> = ({ searchByImageButton }) => {
  if (!searchByImageButton) return null;

  return (
    <FeatureButton
      {...searchByImageButton}
      iconInfo={{ placement: 'left', name: 'SearchByImageIconMd' }}
      target="_blank"
      sizeVariant="small"
      className="searchByImage"
      dangerouslySetClassNames={{ label: 'label' }}
    />
  );
};
